import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withTranslation } from 'react-i18next'

// @ts-ignore
import { showTypeFormPopup } from 'store/entities/typeform/actions'
import { modal } from 'store/entities/modal/actions'
import OnboardingChecklistItems from './OnboardingChecklistItems'
import { triggerAddMobileNumber } from 'store/entities/onBoarding/actions'
import { updateOnboardingChecklist } from 'store/entities/identity/actions'
import { IS_QUIZ_COMPLETED } from 'app/constants/onBoarding'
import {
  getOnboardingSurveyData,
  isPreTrackSurveyEnabled,
  isPostTrackSurveyEnabled,
  getIdentityStage,
  isStageIsProceed,
  isProTrackStopped,
  getIdentityIsWorkingDay,
  getIdentityActivitiesHistoryItems,
  isIntegratedType,
} from 'store/entities/identity/selectors'

const mapStateToProps = createStructuredSelector({
  isPreTrackSurveyEnabled,
  isPostTrackSurveyEnabled,
  getIdentityStage,
  getOnboardingSurveyData,
  isProTrackInProgress: isStageIsProceed,
  isProTrackStopped,
  isWorkingDay: getIdentityIsWorkingDay,
  activityHistoryItems: getIdentityActivitiesHistoryItems,
  isIntegratedType: isIntegratedType,
})

const mapDispatchToProps = {
  hideModal: modal.hide,
  triggerAddMobileNumber,
  updateOnboardingChecklist,
  showTypeFormPopup,
}

const mergeProps = (
  {
    getOnboardingSurveyData,
    isPreTrackSurveyEnabled,
    isPostTrackSurveyEnabled,
    getIdentityStage,
    isProTrackInProgress,
    ...restState
  }: any,
  { showTypeFormPopup, requestSurvey, hideModal, updateOnboardingChecklist, ...restDispatch }: any,
  ownProps: any
) => {
  const isOnlyPostSurveyEnable = !isPreTrackSurveyEnabled && isPostTrackSurveyEnabled
  const isOnlyPreTrackSurveyEnable = isPreTrackSurveyEnabled && !isPostTrackSurveyEnabled
  return {
    ...restState,
    ...ownProps,
    ...restDispatch,
    requestSurvey,
    hideModal,
    isOnlyPreTrackSurveyEnable,
    isOnlyPostSurveyEnable,
    isProTrackInProgress,
    showTypeFormPopup: () =>
      showTypeFormPopup({
        typeFormData: getOnboardingSurveyData,
        onSubmit: () => {
          updateOnboardingChecklist({ propertyName: IS_QUIZ_COMPLETED, propertyValue: true })
          hideModal()
        },
      }),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(withTranslation('user')(OnboardingChecklistItems))
